import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { toast } from 'react-toastify';

import env from '../env';
import logo from '../header_logo.png';
import logo2 from '../header_logo2.png';
import logo3 from '../header_logo3.png';
import logo4 from '../header_logo4.png';
import logo5 from '../header_logo5.png';
import logo6 from '../header_logo6.png';
import logo7 from '../header_logo7.png';
import logo8 from '../header_logo8.png';
import firebase from '../firebase';
import ProposeToReloadBar from './ProposeToReloadBar';

const auth = firebase.auth();
const _logo = ({ 1: logo, 2: logo2, 3: logo3, 4: logo4, 5: logo5, 6: logo6, 7: logo7, 8: logo8, 9: logo, })[env('NUMBER') || '1'];
const holidayEnd = ({ 5: 3, })[env('NUMBER') || '1'] || 4;

export default function HeaderNav (props) {
  const { user, tenant, isOldAppVersion, } = props;
  const onClickLogOut = async () => {
    if(!window.confirm('ログアウトしますか？')) return;
    await auth.signOut();
    window.location.reload();
  };
  const onClickPasswordReset = async () => {
    if(!window.confirm('パスワード変更のためのメールをお送りします。よろしいですか？')) return;
    await auth.sendPasswordResetEmail(user.email)
    toast.success('パスワードリセットのメールをお送りしました。');
  };

  return (
    <header className="header-nav fixed-top">
      <Navbar color="primary" dark className="justify-content-between">
        <div className="d-flex gap-3 align-items-center">
          <Link to="/" className="navbar-brand">
            <img src={_logo} style={{ height: 20 }} />
          </Link>
        </div>
        <Nav navbar className="flex-fill flex-row justify-content-end gap-2 align-items-center">
          {
            tenant != null && (
              <div className="bg-info rounded px-2 py-1 text-light">
                ユーザーID: {tenant.id}
              </div>
            )
          }
          {
            user != null && (
              <UncontrolledDropdown tag="div">
                <DropdownToggle nav caret>
                  {user.displayName || '(ユーザー未設定)'}
                </DropdownToggle>
                <DropdownMenu right>
                  {
                    user.admin && (
                      <DropdownItem tag={Link} to="/admin">
                        管理画面
                      </DropdownItem>
                    )
                  }
                  <DropdownItem tag={Link} to="/mypage/profile">
                    プロフィール
                  </DropdownItem>
                  <DropdownItem onClick={onClickPasswordReset}>
                    パスワード変更
                  </DropdownItem>
                  {
                    tenant != null && (
                      <DropdownItem className="d-none" tag="a" href={`https://console.amacode.app/authorize?client_id=SAP10001&redirect_uri=${window.location.origin}`}>
                        Amacodeと連携
                        {
                          tenant.amacodeIntegratedAt && (
                            <div className="d-block small badge badge-success">
                              連携済み
                            </div>
                          )
                        }
                      </DropdownItem>
                    )
                  }
                  {
                    tenant != null && (
                      <DropdownItem tag="a" href={env('SP_API_AUTH_CONSENT_URI')} className="d-flex flex-column align-items-stretch">
                        <div>SP API認証</div>
                        {tenant.spApi != null && <div className="badge badge-success">認証済み</div>}
                      </DropdownItem>
                    )
                  }
                  <DropdownItem onClick={onClickLogOut}>
                    ログアウト
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )
          }
        </Nav>
      </Navbar>
      {
        isOldAppVersion && (
          <ProposeToReloadBar />
        )
      }
    </header>
  );
};
